<s1-input-mask [control]="control" [label]="_campoValorizzato?.nome" mask="separator.2" thousandSeparator="." decimalMarker="," [allowNegativeNumbers]="false" [customClass]="'text-right'" [readonly]="readonly"></s1-input-mask>
